import React, { useEffect } from 'react';
import { SiteNav } from '../components/sections/SiteNav';
import { Hero } from '../components/sections/Hero';
import { Approach } from '../components/sections/Approach';
import { Overview } from '../components/sections/Overview';
import { Volumes } from '../components/sections/Volumes';
import { InsideGuides } from '../components/sections/InsideGuides';
import { Bonuses } from '../components/sections/Bonuses';
import { Benefits } from '../components/sections/Benefits';
import { Offer } from '../components/sections/Offer';
import { Testimonials } from '../components/sections/Testimonials';
import { FaqSection } from '../components/sections/FaqSection';
import { FinalCta } from '../components/sections/FinalCta';
import { SiteFooter } from '../components/sections/SiteFooter';
import { MobileBuyBar } from '../components/MobileBuyBar';
import { EditorNotes } from '../components/EditorNotes';
const TITLE = 'Diesel Fault Atlas — The Visual Troubleshooting Guide for Diesel Technicians';
const DESCRIPTION = 'Diesel Fault Atlas is a digital reference collection of six visual diesel diagnostic volumes and five professional bonus resources. Trace the symptom. Test the cause.';
export function Landing({
  showEditorNotes
}: {
  showEditorNotes: boolean;
}) {
  useEffect(() => {
    document.title = TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = DESCRIPTION;
  }, []);
  return <div className="w-full overflow-x-hidden bg-ivory font-sans text-ink" data-id="element-230" data-mp="c7ep5a81pok9">
      <SiteNav data-id="element-231" data-mp="79d5oo6pjn89" />
      <main data-id="element-232" data-mp="79wr4evkgtr1">
        <Hero data-id="element-233" data-mp="7826l1o7j3nh" />
        <Approach data-id="element-234" data-mp="78lle9ik9bxa" />
        <Overview data-id="element-235" data-mp="770qujw8xszf" />
        <Volumes data-id="element-236" data-mp="14oipomucs6dr" />
        <InsideGuides data-id="element-237" data-mp="14p0wgden62zx" />
        <Bonuses data-id="element-238" data-mp="14pam1zvry853" />
        <Benefits data-id="element-239" data-mp="14ptsokfz5a3t" />
        <Offer data-id="element-240" data-mp="14qbya7oj10oe" />
        <Testimonials data-id="element-241" data-mp="zy2bv1mmeiqv" />
        <FaqSection data-id="element-242" data-mp="zxiqtc1obe8m" />
        <FinalCta data-id="element-243" data-mp="zx0qo4bw4fvf" />
      </main>
      <SiteFooter data-id="element-244" data-mp="zvxxfpr3i1cc" />
      <MobileBuyBar data-id="element-245" data-mp="1iuaxhse6iksx" />
      {showEditorNotes && <EditorNotes data-id="element-246" data-mp="1ivc6lrbmwx80" />}
    </div>;
}